export const locales = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      dashboard: "Dashboard",
      create: "Create",
      support: "Support",
      terms: "Terms",
      about: "About",
      profile: "Profile",
      skills: "Skills",
    },

    // Home Page
    home: {
      // Beta Banner
      betaBanner: "Public Beta — Free to use, feedback welcome",
      betaFeedback: "Give feedback",

      // Hero
      createLink: "Start selling",

      // How it works
      howItWorks: "How it works",
      howItWorksSubtitle: "See how your payment flows — trustlessly and transparently",
      hiwSubtitle: "Choose your perspective to understand the process",
      hiwTabFlow: "Payment Flow",
      hiwTabSteps: "How to Use",

      // Payment Flow Animation
      pfBuyer: "Buyer",
      pfSeller: "Seller",
      pfSmartContract: "Smart Contract",
      pfOnChain: "ON-CHAIN",
      pfCaption1Main: "Direct peer-to-peer payment",
      pfCaption1Sub: "No middleman. No custody risk.",
      pfCaption2Main: "Secured by smart contract",
      pfCaption2Sub: "Your funds never touch our servers",
      pfCaption3Main: "Instant & transparent",
      pfCaption3Sub: "Every transaction recorded on blockchain",
      pfFeatNonCustodial: "Non-custodial",
      pfFeatInstant: "Instant",
      pfFeatTransparent: "Transparent",

      step1Title: "Upload your content",
      step1Desc: "Files, text, or links — anything digital.",
      step2Title: "Set a price",
      step2Desc: "Choose how much you want to charge in USDC (USD stablecoin).",
      step3Title: "Share the link",
      step3Desc: "Send it anywhere — social, email, DMs.",
      step4Title: "Buyer gets instant access",
      step4Desc: "They pay, you get paid, content delivered instantly.",

      // Why section - 3 Pillars
      whyTitle: "Why this works",
      pillar1Title: "Global buyers",
      pillar1Desc: "Buyers pay in USDC, regardless of their local payment methods.",
      pillar2Title: "Instant delivery",
      pillar2Desc: "Content is delivered automatically after payment. No manual file sending.",
      pillar3Title: "Direct to your wallet",
      pillar3Desc: "Funds go straight to your wallet. Verifiable on-chain.",

      // Use cases
      whoFor: "Who it's for",
      creators: "Creators",
      creatorsDesc: "Sell exclusive content directly to your audience — tutorials, design assets, exclusive photos.",
      developers: "Developers",
      developersDesc: "Monetize code, APIs, or technical resources — source code, technical docs.",
      indieSellers: "Indie sellers",
      indieSellersDesc: "Sell digital products without building a store — ebooks, templates, digital assets.",
      writers: "Writers",
      writersDesc: "Gate articles, reports, or premium content — research reports, newsletters, in-depth articles.",

      // Rules
      rulesTitle: "Important notes",
      ruleWarning: "Buy from trusted sellers only. Beware of scams.",
      rule1: "Payments in USDC (USD stablecoin) on Base network.",
      rule2: "Zero listing fee — only 5% tool usage fee on successful sales.",
      rule3: "Payments are final. No refunds once delivered.",
      rule4: "This tool does not custody funds or provide financial services.",
      rule5: "Content quality is not guaranteed. Use at your own discretion.",
      rule6: "Please ensure compliance with your local regulations.",

      // CTA
      ctaTitle: "Create your first PayLink in minutes.",

      heroSubtitleV2: "Setup once. Your AI agents can package, price, and sell content — automatically.",
      getApiKey: "Get API Key",
      createPayLink: "Create PayLink",

      // Skills Section
      skillsSectionTitle: "Monetization for AI Agents",
      skillsSectionSubtitle: "Configure once. Your agents start charging automatically.",
      skillsCard1Title: "The Missing Revenue Layer",
      skillsCard1Desc: "Your AI agent can generate, answer, and create — but it can't get paid. One API call closes the loop.",
      skillsCard2Title: "Full Auto or Hands-On — You Choose",
      skillsCard2Desc: "Let your agent run the show, or stay hands-on. Need to tweak something? Just tell your agent — no dashboard required.",
      skillsCard3Title: "Plug into Any Agent Stack",
      skillsCard3Desc: "LangChain, CrewAI, Claude MCP, or your custom pipeline. Add Govilo as a tool and ship in minutes.",
      skillsCta: "Get Started with Skills",

      // Footer
      about: "About",
      terms: "Terms",
      support: "Support",
    },

    // Seller Page
    seller: {
      title: "Create PayLink",
      subtitle: "Set up once. Share the link. Get paid.",

      // Section titles
      contentInfo: "Content Information",
      pricing: "Pricing",
      payout: "Payout",
      advanced: "Advanced settings (optional)",

      // Content Information
      fieldTitle: "Title",
      fieldTitlePlaceholder: "e.g. XXX Complete Guide",
      fieldDescription: "Description",
      fieldDescriptionPlaceholder: "Briefly describe what this content is",
      fieldContentType: "Content Type",
      contentTypeFile: "File",
      contentTypeText: "Text",
      contentTypeLink: "Link",
      fieldUploadFile: "Upload File",
      fieldUploadFilePlaceholder: "Select a file...",
      fieldUploadFileHint: "Mock: Enter any filename",
      browseBtn: "Browse",
      fieldContent: "Content",
      fieldContentPlaceholder: "Enter your content here...",
      fieldContentHint: "First 20% will be shown as preview",
      fieldUrl: "URL",
      fieldUrlPlaceholder: "https://...",

      // Pricing
      fieldPrice: "Price",
      pricePlaceholder: "1.00",
      priceUnit: "USDC",
      priceMinError: "Price must be at least 1 USDC",
      priceDecimalError: "Price cannot have more than 2 decimal places",
      priceMaxError: "Price cannot exceed 200 USDC",
      estimated: "(estimated)",

      // Payout
      fieldPayoutAddress: "Payout Address",
      payoutAddressPlaceholder: "0x...",
      payoutAddressHint: "Payments will be sent directly to this address.",
      invalidAddressError: "Invalid Ethereum address format",

      // Advanced
      validDuration: "Valid for",
      minutes: "minutes",
      validDurationHint: "Max 1440 minutes (24 hours)",
      validMinutesMinError: "Duration must be at least 30 seconds",
      validMinutesMaxError: "Duration cannot exceed 24 hours",

      // Actions
      generateBtn: "Generate PayLink",
      generating: "Generating...",

      // Success
      successTitle: "PayLink created!",
      copyLink: "Copy link",
      copied: "Copied",
      createAnother: "Create another",
      previewBuyer: "Preview buyer page",

      // Error
      errorMessage: "Something went wrong. Please try again.",

      // Navigation
      backToHome: "Home",

      // Validation
      required: "*",

      // Multi-file upload
      dropzoneText: "Drop files here or click to browse",
      dropzoneHint: "Up to 20 files, 20 MB total",
      multiFileHint: "Supports multiple files. All files will be packaged as a ZIP for download.",
      fileCount: "{count} file(s)",
      maxFilesError: "Maximum 20 files allowed",
      maxSizeError: "Total size cannot exceed 20 MB",
      removeFile: "Remove file",
      remaining: "Remaining",
      filesRemaining: "files remaining",

      // Presigned URL upload states
      compressing: "Compressing files...",
      compressingProgress: "Compressing: {progress}%",
      gettingUploadUrl: "Getting upload permission...",
      uploadingToCloud: "Uploading to cloud...",
      uploadingProgress: "Uploading: {progress}%",
      creatingItem: "Creating item...",
      sessionExpired: "Upload session expired, please try again",
      rateLimitExceeded: "Too many requests, please try again later",
      zipTooLarge: "Compressed file exceeds 20 MB limit",

      // Turnstile
      turnstileError: "Verification failed, please try again",

      // Coupon
      couponTitle: "Promotional Code",
      couponPlaceholder: "Enter promo code",
      couponRedeem: "Redeem",
      couponRedeeming: "Redeeming...",
      couponCurrentFee: "Current platform fee: {fee}%",
      couponActiveInfo: "Promotion active until {date}",
      couponSuccess: "Promo code redeemed! Platform fee reduced to {fee}%.",
      couponErrorNotFound: "Invalid promo code. Please check and try again.",
      couponErrorNotRedeemable: "This promo code has expired.",
      couponErrorAlreadyRedeemed: "You have already used this promo code.",
      couponErrorAlreadyActive: "You already have an active promotion. Please wait until it expires.",
      couponErrorGeneric: "Failed to redeem promo code. Please try again later.",
      promoCodeLink: "Have a promo code? Go to Settings",
    },

    // Upload Progress Toast
    upload: {
      pendingTitle: "Uploading files...",
      pendingDesc: "Your files are being uploaded to the server",
      processingTitle: "Processing files...",
      processingDesc: "Your files are being processed",
      completedTitle: "Upload complete!",
      completedDesc: "Files are ready",
      failedTitle: "Upload failed",
      failedDesc: "Please try again later",
      buyerWaiting: "File is being prepared, please wait...",
      buyerFailedTitle: "File Unavailable",
      buyerFailedDesc: "The files for this item are no longer available",
    },

    // Preview Banner
    previewBanner: "Preview mode – This is how buyers will see your page",

    // Common
    common: {
      language: "Language",
      loading: "Loading...",
      backToHome: "Back to Home",
    },

    // Unlock Page (Buyer)
    unlock: {
      // Error states
      loadError: "Failed to load",
      itemNotFound: "Item not found",
      itemExpired: "Item Expired",
      itemExpiredDesc: "This item is no longer available",
      // Status messages
      gettingPaymentInfo: "Getting payment info...",
      checkingUnlockStatus: "Checking payment status...",
      checkingBalance: "Checking balance...",
      confirmSignature: "Please sign in wallet...",
      processingTx: "Processing transaction...",
      verifyingPayment: "Waiting for payment confirmation...",
      // Price box
      unlockPrice: "Access price",
      unlockContent: "Get access",
      connectWallet: "Connect wallet",
      switchNetwork: "Switch to {network}",
      installMetaMask: "Please install MetaMask",
      tryAgain: "Try again",
      processing: "Processing...",
      unlocked: "Access granted",
      switchNetworkHint: "Please switch to {network} network",
      // Content
      whatYouGet: "What you get",
      copyLink: "Copy link",
      unlockForFullLink: "Pay to get full link",
      unlockForFullText: "Pay to view full content",
      downloadFile: "Download file",
      // Multi-file display
      multipleFiles: "Multiple files",
      files: "files",
      totalFiles: "{count} files included",
      // Footer
      terms: "Terms",
      support: "Support",
      about: "About",

      // Viral Loop
      poweredBy: "Powered by Govilo PayLink",
      createYourOwn: "You also have exclusive content? Create your PayLink for free",
      createBtn: "Create my link",
      // Countdown & time limit
      timeRemaining: "Time remaining",
      expired: "Expired",
      timeLimited: "Time limited, cannot purchase",
      timeLimitWarning: "Less than 10 minutes remaining, cannot purchase",
      expiredNotice: "This link has expired",
    },

    // Wallet errors
    wallet: {
      installMetaMask: "Please install MetaMask wallet",
      userCancelled: "User cancelled",
      connectFailed: "Failed to connect wallet",
      switchNetworkFailed: "Failed to switch network",
      addNetworkFailed: "Failed to add {network} network",
      getStatusFailed: "Failed to get wallet status",
      switchAccountFailed: "Failed to switch account",
      selectWallet: "Select Wallet",
      coinbaseDesc: "Smart Wallet or App",
      metamaskDesc: "Browser Extension or App",
      recommended: "Recommended",
      popupBlockedTitle: "Please allow pop-ups",
      popupBlockedDesc: "Tap the pop-up icon in the address bar and select \"Allow\", then try again",
      popupBlockedRetry: "Try Again",
      popupHintSmall: "No response? Click \"Retry\" in the popup notice or allow pop-ups",
    },

    // Payment errors
    payment: {
      getAddressFailed: "Failed to get wallet address",
      getPermitFailed: "Failed to get payment parameters",
      getStatusFailed: "Failed to get payment status",
      verifyFailed: "Payment verification failed",
      verifyTimeout: "Payment verification timeout",
      getTokenFailed: "Failed to get download token",
      submitFailed: "Payment submission failed",
      userCancelled: "User cancelled the operation",
      networkError: "Network error, please try again later",
      failed: "Payment failed, please try again later",
      missingItemId: "Missing item ID",
      loadItemFailed: "Failed to load item",
      itemInvalid: "This item's files are no longer available",
    },

    // Download page
    download: {
      invalidLink: "Invalid download link",
      invalidLinkDesc: "This link is invalid or has expired",
      success: "Payment successful!",
      successDesc: "Payment successful! Click below to download your content.",
      downloadBtn: "Download file",
      tokenExpired: "Download link has expired",
      tokenUsed: "Download link has already been used",
      downloadFailed: "Download failed, please try again",
    },

    // Terms Modal
    termsModal: {
      // TOS
      tosTitle: "Terms of Service",
      tosAcceptBtn: "I Agree",
      tosLink: "View full Terms of Service",

      // Buyer
      buyerTitle: "Platform Disclaimer",
      buyerContent: "Please confirm and agree to the following terms before purchasing:",
      buyerItem1: "I understand this is a digital content unlock service, and I will receive access immediately after payment.",
      buyerItem2: "I will review the content description, price, and any limitations before purchasing, and I am fully responsible for my payment decision.",
      buyerItem3: "All payments are final. No refunds or cancellations.",
      buyerItem4: "The Platform only provides payment and unlock tools and is not a party to the transaction. Any issues regarding content quality, accuracy of description, or disputes shall be handled between the buyer and seller.",
      buyerItem5: "Blockchain transactions are irreversible. I will verify the network, amount, and wallet address before paying. Any loss caused by incorrect payment is my sole responsibility.",
      buyerItem6: "I understand and agree to take precautions against scams and only pay sellers I trust. If I am scammed or encounter any transaction dispute, the Platform cannot intervene, cannot recover funds, and will not provide compensation.",
      buyerAcceptBtn: "I Understand and Agree, Continue",

      // Seller
      sellerTitle: "Platform Disclaimer",
      sellerContent: "Please confirm and agree to the following terms before listing:",
      sellerItem1: "I confirm I have the right to provide and sell this content, and it does not infringe any third-party rights (including copyright, portrait rights, privacy, etc.).",
      sellerItem2: "I warrant that the content is lawful and does not include infringing/pirated materials, unauthorized leaks, inappropriate content involving minors, fraud, money laundering, or any other illegal use.",
      sellerItem3: "I am solely responsible for the content description, pricing, delivery, and after-sales policy. I will bear all consequences arising from unclear descriptions or consumer disputes.",
      sellerItem4: "The Platform only provides payment and unlock technology, does not review content, and does not guarantee transactions. The Platform is not liable for any disputes or damages.",
      sellerItem5: "I understand blockchain settlement is irreversible. Any loss caused by my misconfiguration (including receiving address or content settings) is my sole responsibility.",
      sellerItem6: "If the Platform reasonably suspects any content or transaction involves illegality or high risk, the Platform may restrict or suspend services, and I will not claim compensation from the Platform.",
      sellerAcceptBtn: "I Understand and Agree, Continue",

      // Common
      cancel: "Cancel",
      processing: "Processing...",
      scrollToRead: "Please scroll down to read the full terms",
    },

    // Terms of Service
    terms: {
      title: "Terms of Service",
      subtitle: "Platform-based Digital Content Paid Unlock Service",
      lastUpdated: "Last Updated",

      // Section 1 - Introduction and Acceptance of Terms
      section1Title: "1. Introduction and Acceptance of Terms",
      section1Content: "Welcome to this platform (the \"Platform\"). By accessing, browsing, or using any services provided by the Platform, you acknowledge that you have fully read, understood, and agreed to be bound by these Terms of Service (the \"Terms\") and all related policies (including but not limited to the Privacy Policy and Acceptable Use Policy).",
      section1Warning: "If you do not agree to any part of these Terms, please immediately stop using the Platform and its services.",

      // Section 2 - Description of Services
      section2Title: "2. Description of Services",
      section2Content1: "The Platform provides technical and system tools for paid unlocking of digital content, enabling content providers (the \"Seller\") to grant users (the \"Buyer\") access rights to digital content through smart contracts, blockchain transactions, or specific access links.",

      // 2.1 Technical Nature and Non-Custodial Declaration
      section2_1Title: "2.1 Technical Nature and Non-Custodial Declaration",
      section2_1Intro: "Users understand and agree that the Platform's services are of a \"technical tool / software system\" nature, including but not limited to:",
      section2_1Item1: "Assisting Sellers in creating content unlock pages or access links;",
      section2_1Item2: "Providing unlock verification and access permission activation after Buyer payment;",
      section2_1Item3: "Displaying payment status, unlock status, and access records based on publicly verifiable on-chain transaction information or system records;",
      section2_1Item4: "Providing reporting, risk control, takedown, and access restriction management mechanisms.",
      section2_1NonCustody: "The Platform does not provide, nor is it involved in, any form of asset custody or safekeeping services. The Platform does not hold user private keys, does not sign transactions on behalf of users, and has no unilateral ability to control, transfer, or dispose of user crypto assets. All crypto asset transfers are completed by users' self-controlled wallets according to their instructions on the blockchain network. The Platform does not provide any collection/payment agency or fund intermediary services.",

      // 2.2 Platform Is Not a Transaction Party
      section2_3Title: "2.2 Platform Is Not a Transaction Party",
      section2_3Content: "The Platform acts solely as a technology tool and system provider. The Platform is not a party to any transaction between the Seller and the Buyer, and does not directly provide, control, review, guarantee, or custody any content or crypto assets offered by Sellers. The legal relationship established between the Buyer and the Seller regarding content transactions is solely the responsibility of the Seller and the Buyer.",

      // Section 3 - User Roles and Responsibilities
      section3Title: "3. User Roles and Responsibilities",

      // 3.1 Seller Responsibilities
      section3_1Title: "3.1 Seller Responsibilities",
      section3_1Intro: "The Seller bears full and independent legal responsibility for their content and transactions, and shall indemnify the Platform against all claims related thereto.",
      section3_1ContentDef: "The Seller acknowledges and agrees that any content, files, links, materials, text descriptions, images, audio/video, services, rights, licenses, or other digital goods provided, listed, sold, published, displayed, transmitted, delivered, or otherwise made accessible to Buyers through the Platform (collectively, \"Seller Content\") shall be solely and exclusively the Seller's responsibility. The Platform merely provides technical tools and makes no express or implied warranties regarding the legality, accuracy, completeness, security, quality, availability, or fitness of Seller Content.",
      section3_1WarrantyIntro: "The Seller hereby represents, warrants, and undertakes as follows:",

      // Seller warranty items
      section3_1LegalTitle: "Legality and Compliance Obligations",
      section3_1LegalContent: "The Seller Content and the Seller's transaction activities shall comply with all applicable laws, regulations, orders, rules, and requirements imposed by competent authorities or regulators (including but not limited to consumer protection, personal data protection, intellectual property, criminal laws, anti-money laundering and counter-terrorist financing requirements). The Seller shall obtain all required qualifications, authorizations, permits, and consents as required by law.",

      section3_1ProhibitedTitle: "Prohibited Illegal Use and High-Risk Transactions",
      section3_1ProhibitedIntro: "The Seller shall not use the Platform for any illegal or improper purpose, including but not limited to:",
      section3_1ProhibitedItem1: "Fraud, scams, false sales, investment scams, Ponzi schemes, or any deceptive fundraising activity",
      section3_1ProhibitedItem2: "Money laundering, terrorist financing, illegal fundraising, concealment or layering of funds, acting as a payment intermediary, or any financial crime",
      section3_1ProhibitedItem3: "Using \"content\" as a pretext for illegal fund transfers, disguised collection of funds, token sales, or regulatory evasion",
      section3_1ProhibitedItem4: "Any content or behavior that incites, assists, or induces others to commit crimes",

      section3_1ContentTitle: "Prohibited Content Types (Illegal and High-Risk Content)",
      section3_1ContentIntro: "The Seller shall not provide, sell, share, or make accessible any content including but not limited to the following:",
      section3_1ContentItem1: "Unauthorized pirated content, infringing materials, cracked software, license keys, cracking tutorials, or any materials infringing intellectual property rights",
      section3_1ContentItem2: "Obscene, pornographic, explicit sexual content, or any content involving sexual violence or sexual exploitation",
      section3_1ContentItem3: "Any inappropriate content involving minors, including exploitation, sexual implications, nudity, or any content potentially violating applicable laws",
      section3_1ContentItem4: "Violent, gory, cruel, threatening, hateful, discriminatory, or incitement content",
      section3_1ContentItem5: "Content that infringes others' privacy (e.g., leaked personal data, secret recordings, leaked videos, chat logs, location information without consent, etc.)",
      section3_1ContentItem6: "Any content or service that is prohibited by law, requires special authorization, or may expose the Platform to significant legal risk",

      section3_1MisleadingTitle: "No Misleading or False Statements",
      section3_1MisleadingContent: "The Seller shall provide complete, clear, and truthful information regarding the title, description, samples, delivery method, usage restrictions, pricing, risk disclosures, applicable conditions, and other transaction-related information of Seller Content. The Seller shall not make any false, exaggerated, materially omitted, misleading, or deceptive statements or conduct.",

      section3_1IPTitle: "Intellectual Property and Third-Party Rights Assurance",
      section3_1IPContent: "The Seller warrants that the Seller Content does not infringe any third party's lawful rights, including but not limited to copyrights, trademarks, patents, trade secrets, other intellectual property rights, privacy rights, personal data rights, portrait rights, name rights, reputation rights, or other legally protected rights. If the Seller Content includes third-party materials (including images, music, videos, fonts, source code, models, datasets, etc.), the Seller shall obtain lawful authorization at their own expense and bear all related responsibilities.",

      section3_1DeliveryTitle: "Seller Handles Delivery, After-Sales Support, and Disputes",
      section3_1DeliveryContent: "The Seller shall be responsible for content delivery, licensing methods, download/access methods, after-sales support, and responding to Buyer inquiries. The Seller shall also bear all responsibilities arising from disputes between the Seller and the Buyer, including but not limited to issues related to content quality, delivery defects, discrepancies, licensing scope, after-sales matters, or any other disputes. The Platform has no obligation to deliver, review, guarantee, warrant, or arbitrate Seller Content.",

      section3_1DisputeTitle: "Dispute and Complaint Handling",
      section3_1DisputeContent: "Any Buyer complaints, objections, disputes, refund requests, or claims relating to Seller Content shall be handled and responded to by the Seller. The Seller acknowledges and agrees that the Platform may, for risk control or lawful purposes, require the Seller to provide necessary transaction information, explanatory documents, or proof of rights to assist in handling complaints or investigations.",

      section3_1EnforcementTitle: "Risk Control Measures and Enforcement Rights",
      section3_1EnforcementIntro: "For legal compliance, risk control, user protection, or where the Platform reasonably suspects abnormal Seller activity, the Platform may take the following measures without prior notice:",
      section3_1EnforcementItem1: "Restrict, suspend, or terminate the Seller's access to all or part of the Platform features",
      section3_1EnforcementItem2: "Remove, take down, block, or disable Seller Content or related links",
      section3_1EnforcementItem3: "Require the Seller to provide identity verification, proof of rights, authorization documents, or supplementary explanations",
      section3_1EnforcementItem4: "Cooperate with competent authorities, judicial authorities, or other entities with lawful authority by providing necessary information",

      section3_1IndemnityTitle: "Indemnification",
      section3_1IndemnityContent: "If the Seller's conduct or Seller Content (including but not limited to illegality, infringement, fraud, money laundering, misleading statements, disputed transactions, or any violation of these Terms) causes the Platform, its affiliates, shareholders, directors, employees, partners, or agents to be subject to any third-party or governmental claims, complaints, investigations, penalties, seizures, lawsuits, or arbitration, the Seller shall bear full responsibility for handling and resolving such matters and shall indemnify the Platform for all losses, costs, and expenses incurred (including but not limited to legal fees, litigation costs, settlement amounts, administrative fines, and reputational damages).",

      section3_1SurvivalTitle: "Continuing Effect",
      section3_1SurvivalContent: "The obligations and liabilities under Section 3.1 shall survive the Seller's discontinuation of Platform use, deletion of content, or termination of services and shall remain effective.",

      // 3.2 Buyer Responsibilities
      section3_2Title: "3.2 Buyer Responsibilities",
      section3_2Intro: "The Buyer must carefully evaluate content descriptions, transaction terms, and risks before making payment. The Buyer acknowledges and agrees as follows:",

      section3_2JudgeTitle: "Buyer Must Independently Assess Content and Transaction Suitability",
      section3_2JudgeContent: "Before payment, the Buyer shall verify the Seller's content description, delivery method, licensing scope, usage restrictions, compatibility, risk disclosures, and any conditions, and determine whether it meets the Buyer's needs. The Buyer understands and agrees that the Platform does not review or guarantee the quality, accuracy, legality, or suitability of Seller Content.",

      section3_2NoGuaranteeTitle: "Platform Is Not a Guarantee Mechanism",
      section3_2NoGuaranteeContent: "The Buyer understands and agrees that the Platform only provides technical tools and unlocking mechanisms and is not a party to the transaction. The Platform does not provide transaction guarantees, performance assurances, escrow services, arbitration, or recovery services.",

      section3_2BlockchainTitle: "Transactions Are Initiated by Buyer's Self-Controlled Wallet and Executed via Blockchain and Smart Contracts",
      section3_2BlockchainContent: "Transactions are signed and broadcast by the Buyer's self-controlled wallet and executed by the blockchain network and USDC official smart contract according to their rules. The Buyer understands and agrees that once the Buyer signs, authorizes, or pays via their wallet (including but not limited to transfer), the Buyer is deemed to have confirmed and accepted the transaction terms and outcome.",

      section3_2ControlTitle: "Payment Assets Transfer to Seller Address After Completion, Buyer Obtains Content Access",
      section3_2ControlContent: "After transaction confirmation, the USDC used for payment will be transferred to the Seller's designated receiving address according to the blockchain transaction result; the Buyer obtains access or download rights to the purchased Seller Content (depending on the Seller's delivery method). The Platform does not guarantee the quality or completeness of Seller Content delivery.",

      section3_2IrreversibleTitle: "Blockchain Transactions Are Irreversible",
      section3_2IrreversibleContent: "Blockchain transactions are irreversible and beyond the Platform's control. Once a transaction is confirmed on-chain or becomes non-reversible, it may not be cancellable or recoverable.",

      section3_2NoRefundTitle: "Platform Cannot Reverse, Intercept, Rollback, or Refund Transactions",
      section3_2NoRefundContent: "Once payment is completed and access is granted, the transaction is final and non-cancellable. The Buyer confirms that because the transaction is executed through on-chain transactions initiated by the Buyer, the Platform has no technical capability or legal obligation to reverse, intercept, rollback, or refund any transaction. If the Buyer needs a refund or dispute resolution, they should negotiate directly with the Seller.",

      section3_2AccessRiskTitle: "Content Access and Delivery Risks",
      section3_2AccessRiskContent: "The Buyer understands that Seller Content may be delivered through file downloads, unlock pages, external links, third-party storage services, or other means. The Buyer must ensure their device, network environment, browser, security settings, and compatibility are sufficient to access the content. The Platform shall not be liable for losses caused by Buyer-side factors, including device failure, network interruptions, compatibility issues, wallet operational errors, wrong addresses, wrong chains, mistaken signatures, or other Buyer actions.",

      section3_2FeesTitle: "Transaction Fees and On-Chain Costs",
      section3_2FeesContent: "The Buyer understands that in addition to the content payment amount, blockchain transaction fees (gas fees) or other third-party fees may apply. Such fees are charged by the blockchain network or third parties and are not controlled or refundable by the Platform.",

      section3_2DirectDisputeTitle: "Disputes Between Buyer and Seller",
      section3_2DirectDisputeContent: "If any disputes arise (including but not limited to content defects, discrepancies, delivery issues, or misrepresentation), the Buyer shall pursue claims directly against the Seller. The Platform is not a party to the transaction and is not responsible for coordination, arbitration, or guaranteeing Seller performance.",

      section3_2LegalUseTitle: "Lawful Use of Content",
      section3_2LegalUseContent: "The Buyer shall not use unlocked content for illegal purposes, nor illegally distribute, reproduce, resell, share, or otherwise infringe the Seller's or any third party's rights. If the Buyer violates these obligations, the Buyer shall bear full legal responsibility.",

      // Section 4 - Payment and Transaction Nature
      section4Title: "4. Payment and Transaction Nature",
      section4Content1: "The Platform only supports payment via crypto assets (e.g., stablecoin USDC) and does not support any fiat currency transactions.",
      section4Content2: "Users acknowledge and agree:",
      section4Item1: "The Platform is not a financial institution, payment institution, or electronic payment service provider.",
      section4Item2: "The Platform does not participate in, custody, or control any user funds or crypto assets.",
      section4Item3: "The Platform does not provide virtual asset exchange, trade matching, or payment collection/agency services.",
      section4Item4: "Transaction outcomes depend entirely on blockchain networks and smart contract execution status.",
      section4Item5: "The Platform charges Sellers a 5% tool usage fee on successful transactions only. Buyers are not charged any tool usage fees.",
      section4Item6: "Any changes to the fee structure will be announced on the Platform.",

      // Section 5 - Platform Role and Limitation of Responsibility
      section5Title: "5. Platform Role and Limitation of Responsibility",
      section5Content1: "The Platform is not an agent, guarantor, or representative of either the Buyer or the Seller, and is not an investment, financial, or advisory service provider.",
      section5Content2: "The Platform shall not be liable for:",
      section5Item1: "The quality, legality, accuracy, or suitability of Seller Content.",
      section5Item2: "Any disputes between Buyers and Sellers.",
      section5Item3: "Any direct or indirect losses arising from use of or access to content.",
      section5Item4: "Any losses arising from failures, delays, or anomalies in third-party wallets, blockchain networks, nodes/RPC, USDC smart contracts, or other third-party services.",

      // Section 6 - Intellectual Property
      section6Title: "6. Intellectual Property",
      section6Content1: "The Platform's systems, code, interface design, and marks are owned by the Platform or its lawful rights holders.",
      section6Content2: "Intellectual property rights in Seller Content remain with the Seller or the original rights holders.",

      // Section 7 - Access Methods and User Security
      section7Title: "7. Access Methods and User Security",
      section7Content1: "Certain services may not require registration and may rely on wallet signatures, transaction records, or specific links for access.",
      section7Content2: "Users shall properly safeguard their wallets, private keys, and access credentials. The Platform shall not be liable for losses caused by a user's own negligence.",

      // Section 8 - Service Suspension and Termination
      section8Title: "8. Service Suspension and Termination",
      section8Content: "The Platform may suspend, restrict, or terminate all or part of its services at any time, including but not limited to system maintenance, legal requirements, or abnormal usage behavior.",

      // Section 9 - Disclaimer
      section9Title: "9. Disclaimer",
      section9Content1: "The Platform provides services on an \"as-is\" basis and makes no warranty that services will be uninterrupted, timely, or error-free.",
      section9Content2: "To the maximum extent permitted by law, the Platform shall not be liable for any indirect, incidental, consequential, or punitive damages.",

      // Section 10 - Amendment of Terms
      section10Title: "10. Amendment of Terms",
      section10Content: "The Platform may revise these Terms at any time. The revised Terms shall become effective upon publication on the Platform.",

      // Section 11 - Governing Law and Dispute Resolution
      section11Title: "11. Governing Law and Dispute Resolution",
      section11Content1: "The interpretation and application of these Terms shall be governed by the laws of the Platform's principal place of business/operation.",
      section11Content2: "Any disputes arising from these Terms or Platform services shall first be resolved through good-faith negotiation. If negotiation fails, disputes shall be submitted to the court with jurisdiction in the Platform's principal place of business/operation or other lawful dispute resolution mechanisms.",

      // Section 12 - Risk Disclosure & Anti-Fraud Notice
      section12Title: "12. Risk Disclosure & Anti-Fraud Notice",
      section12Intro: "Users understand and agree that the Platform involves blockchain and smart contract technology and carries risks including but not limited to:",
      section12Risk1Title: "Irreversibility Risk",
      section12Risk1Content: "Once confirmed, blockchain transactions are generally irreversible.",
      section12Risk2Title: "Wrong Address/Wrong Chain Risk",
      section12Risk2Content: "Entering an incorrect address, selecting an incorrect chain, or mistaken authorization may cause permanent loss of assets.",
      section12Risk3Title: "Smart Contract and Third-Party Risk",
      section12Risk3Content: "Transactions may be affected by smart contracts, wallet providers, RPC/nodes, or network congestion.",
      section12Risk4Title: "Content Fraud Risk",
      section12Risk4Content: "Sellers may provide false descriptions, fail to deliver content, deliver malicious links, or conduct other fraudulent behavior.",
      section12ScamWarning: "The Platform reminds Buyers to verify Seller information and content descriptions before payment, and avoid common fraud scenarios such as:",
      section12ScamItem1: "Using \"limited time\" or \"guaranteed profit\" claims to induce quick payment",
      section12ScamItem2: "Redirecting users to non-official pages demanding additional transfers or requesting private keys/seed phrases",
      section12ScamItem3: "Providing suspicious files, phishing links, or demanding additional payment after unlocking",
      section12Disclaimer: "The Platform does not guarantee that all fraud can be prevented. However, the Platform will handle reports and abnormal behavior within reasonable scope pursuant to these Terms and internal risk control measures.",

      // Section 13 - Reporting, Enforcement, and Provision of On-Chain Information
      section13Title: "13. Reporting, Enforcement, and Provision of On-Chain Information",

      section13ReportTitle: "Reporting Mechanism",
      section13ReportContent: "If users discover suspected fraud, infringement, illegal content, or abnormalities, they may report to the Platform. The Platform may request supporting information (e.g., page links, transaction hashes, screenshots, chat logs) for handling.",

      section13EnforcementTitle: "Reasonable Enforcement Actions",
      section13EnforcementIntro: "Where the Platform reasonably suspects fraud or violations, it may take actions including but not limited to:",
      section13EnforcementItem1: "Taking down or restricting access to the suspected content/link",
      section13EnforcementItem2: "Restricting, suspending, or terminating the suspected Seller's access rights",
      section13EnforcementItem3: "Preserving relevant records for investigation or lawful cooperation",

      section13InfoTitle: "Scope of Information the Platform Can Provide",
      section13InfoContent: "Users understand and agree that the Platform may provide or assist in compiling only information related to Platform system records and publicly verifiable on-chain transaction data (e.g., transaction hashes, contract addresses, event logs). The Platform does not guarantee it can obtain or provide any information not possessed by the Platform.",

      section13NoRecoveryTitle: "No Guarantee of Recovery",
      section13NoRecoveryContent: "Users understand and agree that the Platform is not a law enforcement agency or arbitration institution. Platform actions do not imply recovery of losses, reversal of transactions, or guaranteed compensation outcomes.",

      // Section 14 - Compliance Cooperation and Record Retention
      section14Title: "14. Compliance Cooperation and Record Retention",
      section14Content1: "Users understand and agree that for legal compliance and risk control purposes, the Platform may retain necessary system records within a reasonable scope (e.g., device/browser information, access logs, transaction-related identifiers).",
      section14Content2: "If required by laws, regulators, or judicial authorities, the Platform may provide necessary information or cooperate with investigations within the scope permitted by law. Users agree that such data processing and provision does not constitute any guarantee or assumption of liability by the Platform.",

      // Section 15 - Limitation of Liability
      section15Title: "15. Limitation of Liability",
      section15Intro: "To the maximum extent permitted by law, users understand and agree that:",
      section15Item1: "The Platform is not liable for any damages arising from Seller Content or Seller conduct.",
      section15Item2: "The Platform is not liable for damages arising from blockchain irreversibility, third-party wallet/network/service failures, or user operational mistakes.",
      section15Item3: "Even if the Platform is held partially liable, the Platform's total liability shall be limited to the total amount of service fees actually paid by the user to the Platform during the twelve (12) months preceding the event giving rise to the dispute (if no payment was made, the cap shall be United States Dollars (USD) zero), and shall exclude any indirect, incidental, consequential, or punitive damages.",

      // Appendix 1 - Acceptable Use Policy (AUP)
      appendix1Title: "Appendix 1: Acceptable Use Policy (AUP)",
      appendix1Intro: "(This Appendix forms an integral part of these Terms and has the same legal effect.)",
      appendix1Purpose: "To maintain user safety, prevent illegal content circulation, and reduce legal risks, all users (including Sellers and Buyers) must comply with the following Acceptable Use Policy.",

      appendix1ContentTitle: "I. Prohibited Content",
      appendix1ContentIntro: "Users shall not provide, sell, distribute, share, or direct access to any of the following (including but not limited to text, images, audio/video, files, links, code, or any form of content):",
      appendix1ContentItem1: "Infringing intellectual property or unauthorized pirated content (including cracks, license keys, illegal reproductions, unauthorized course materials, leaked paid content, etc.)",
      appendix1ContentItem2: "Obscene, pornographic, explicit sexual content, or content involving sexual violence or exploitation",
      appendix1ContentItem3: "Inappropriate content involving minors (including nudity, sexual implications, or exploitation)",
      appendix1ContentItem4: "Violent, gory, abusive, threatening, hateful, or discriminatory content",
      appendix1ContentItem5: "Privacy-infringing content (including leaked personal data, secret recordings, leaked videos, non-consensual chat logs, or location data, etc.)",
      appendix1ContentItem6: "Any content or services prohibited by law or requiring special authorization",

      appendix1BehaviorTitle: "II. Prohibited Conduct",
      appendix1BehaviorIntro: "Users shall not engage in any of the following:",
      appendix1BehaviorItem1: "Fraud, scams, phishing, impersonation, or false sales",
      appendix1BehaviorItem2: "Money laundering, terrorist financing, illegal fundraising, acting as a payment intermediary, concealment of funds, regulatory evasion, or other financial crimes",
      appendix1BehaviorItem3: "Distribution of malware, viruses, trojans, ransomware, or providing hacking tools or intrusion tutorials",
      appendix1BehaviorItem4: "Unauthorized access to Platform systems, interference with services, scraping attacks, DoS/DDoS attacks, or any destructive actions",
      appendix1BehaviorItem5: "Harassment, threats, intimidation, bullying, hate speech, or discriminatory conduct",
      appendix1BehaviorItem6: "Any activity violating public order or good morals",

      appendix1EnforcementTitle: "III. Platform Enforcement",
      appendix1EnforcementContent: "If the Platform believes a user's conduct or content violates this policy or poses risk, the Platform may take actions without prior notice, including removing, blocking, taking down content, or restricting/terminating access, and may cooperate with competent authorities as required by law.",

      // Appendix 2 - Notice & Takedown Procedure
      appendix2Title: "Appendix 2: Notice & Takedown Procedure",
      appendix2Intro: "(This Appendix forms an integral part of these Terms and has the same legal effect.)",
      appendix2Purpose: "The Platform respects intellectual property rights and lawful third-party rights. If a rights holder or authorized representative believes content on the Platform infringes their rights, they may submit a notice in accordance with the following procedure.",

      appendix2NoticeTitle: "I. Notice Requirements",
      appendix2NoticeIntro: "The rights holder should provide the following information (the more complete, the faster the Platform can respond):",
      appendix2NoticeItem1: "Name/Entity name and contact information (email, phone, etc.)",
      appendix2NoticeItem2: "Proof of rights or a rights statement (e.g., copyright registration, license authorization, trademark registration, etc.)",
      appendix2NoticeItem3: "Specific location of the allegedly infringing content (e.g., product page link, content identifiers)",
      appendix2NoticeItem4: "A statement confirming the notifier is the rights holder or authorized representative",
      appendix2NoticeItem5: "A statement confirming the notice is true and that the notifier accepts legal responsibility for false claims",

      appendix2ProcessTitle: "II. Platform Handling Procedure",
      appendix2ProcessContent: "Upon receipt of a notice, the Platform may take actions based on the case, including temporary takedown, restricting access, notifying the Seller to provide proof of authorization or supplementary explanation, etc.",

      appendix2CounterTitle: "III. Seller Counter Notice",
      appendix2CounterContent: "If the Seller claims the content is non-infringing or properly authorized, the Seller may submit a counter notice with supporting documentation. The Platform may decide whether to restore the content or maintain the takedown based on the circumstances.",

      appendix2RepeatTitle: "IV. Repeat Infringement and Account Actions",
      appendix2RepeatContent: "The Platform may restrict, suspend, or terminate access for Sellers who are repeatedly suspected of infringement, repeatedly violate these Terms, or pose significant legal risk.",

      appendix2LiabilityTitle: "V. Limitation of Liability",
      appendix2LiabilityContent: "Users understand and agree that the Platform merely provides technical tools and is not the provider of infringing content nor a party to the transaction. Final responsibility for infringement disputes remains solely with the content provider (Seller).",
    },

    // Support Page
    support: {
      title: "Support",
      subtitle: "We're here to help",

      // Contact
      contactTitle: "Contact Us",
      contactDesc: "Have questions or need assistance? Send us an email and we'll get back to you.",
      responseTime: "We typically respond within 24-48 hours.",

      // FAQ
      faqTitle: "Frequently Asked Questions",

      faq1Question: "What is Govilo PayLink?",
      faq1Answer: "Govilo PayLink is a digital content payment tool that lets you sell files, text, or links through a simple payment link. Buyers pay with USDC on the Base blockchain, and content is delivered automatically after payment.",

      faq2Question: "How do I get paid?",
      faq2Answer: "Payments go directly to your wallet address. When you create a PayLink, you specify your payout address, and funds are sent there immediately upon purchase. The platform never holds your money.",

      faq3Question: "What payment methods are supported?",
      faq3Answer: "We currently support USDC payments on the Base blockchain. Buyers need a compatible wallet (like Coinbase Wallet or MetaMask) to make purchases.",

      faq4Question: "Can I get a refund?",
      faq4Answer: "Due to the nature of blockchain transactions and instant digital content delivery, all sales are final. Payments cannot be reversed or refunded once completed.",

      faq5Question: "What fees does the platform charge?",
      faq5Answer: "The platform charges sellers a 5% tool usage fee only on successful transactions. Buyers pay no tool usage fees. Additionally, buyers may need to pay a small blockchain gas fee (approximately $0.1).",

      faq6Question: "How long are PayLinks valid?",
      faq6Answer: "When creating a link, you can set the validity period (up to 24 hours). Once the link expires, it can no longer be purchased or downloaded. Please complete your download within the valid period.",

      faq7Question: "I have enough USDC but can't purchase. Why?",
      faq7Answer: "You need a tiny amount of ETH (approximately $0.1) to pay the network fee (called \"gas\"). Think of it like a small postage fee to send your payment on the blockchain.",

      faq8Question: "Why should I trust this platform?",
      faq8Answer: "The payment process is fully transparent. Every step from payment to receipt is recorded on the blockchain for you to verify anytime.",
      faq8Link: "View contract on Basescan",
      faq8LinkUrl: "https://basescan.org/address/0xF40e8a42250D140CcdD312aC93AFCB1b0c5f935C",

      // Getting Started Section
      gettingStartedTitle: "Getting Started",

      walletTitle: "What is a payout address?",
      walletDesc: "A payout address is your crypto wallet address where you'll receive payments. It looks like this: 0x1234...abcd. If you don't have a wallet yet, you can create one for free:",
      walletLink1: "Coinbase Wallet",
      walletLink1Desc: "Best for beginners, simple and intuitive",
      walletLink1Badge: "Recommended",
      walletLink2: "MetaMask",
      walletLink2Desc: "Popular browser extension",
      walletGuideLink: "How to create a wallet (beginner guide)",

      baseTitle: "What is Base?",
      baseDesc: "Base is a blockchain network built by Coinbase. It's fast, low-cost, and secure. All transactions on Govilo PayLink happen on Base, which means lower fees compared to Ethereum mainnet.",
      baseLink: "Learn more about Base",

      usdcTitle: "What is USDC?",
      usdcDesc: "USDC is a stablecoin pegged 1:1 to the US Dollar. Unlike volatile cryptocurrencies, 1 USDC always equals $1 USD. It's issued by Circle and is one of the most trusted stablecoins.",
      usdcLink: "Learn more about USDC",

      // Report
      reportTitle: "Report an Issue",
      reportDesc: "We can help with technical issues and content policy violations. Please email us for:",
      reportItem1: "Technical problems (payment errors, download issues, etc.)",
      reportItem2: "Copyright infringement reports",
      reportItem3: "Illegal or policy-violating content takedown requests",
      reportInclude: "Please include:",
      reportIncludeItem1: "The link or page URL",
      reportIncludeItem2: "Screenshots if applicable",
      reportIncludeItem3: "Detailed description of the issue",
      reportNote: "Note: Due to the nature of blockchain transactions, we cannot reverse or refund completed payments.",
    },

    // Auth
    auth: {
      loading: "Loading...",
      loginRequired: "Sign in to continue",
      loginRequiredDesc: "Sign in with your Google account to create PayLinks.",
      signInWithGoogle: "Sign in with Google",
      logout: "Sign out",
      profile: "Profile",
      loginError: "Login failed, please try again",
      sessionExpired: "Session expired, please sign in again",
      inAppBrowserWarning: "Google Sign-In doesn't work in this browser. Please open in Safari or Chrome.",
      copyUrl: "Copy URL to open in browser",
      urlCopied: "URL Copied!",
    },

    // Dashboard
    dashboard: {
      title: "Dashboard",
      totalRevenue: "Total Revenue",
      itemsSold: "Items Sold",
      activeLinks: "Active Links",
      myLinks: "My PayLinks",
      createNew: "Create New",
      noLinks: "No links yet",
      noLinksDesc: "Create your first PayLink to start selling",
      active: "Active",
      expired: "Expired",
      copyLink: "Copy Link",
      linkCopied: "Copied!",
      viewDetails: "View Details",
      sales: "Sales",
      created: "Created",
      expires: "Expires",
      expiresIn: "{time} left",
      expiredAgo: "Expired {time} ago",
      timeMinutes: "{n}m",
      timeHours: "{n}h",
      timeHoursMinutes: "{h}h {m}m",
      timeDays: "{n}d",
      price: "Price",
      status: "Status",
      itemTitle: "Title",
      revenue: "Revenue",
      welcomeBack: "Welcome back",
      prevPage: "Previous",
      nextPage: "Next",
      sessionExpired: "Session Expired",
      sessionExpiredDesc: "Your session has expired. Please sign in again to continue.",
      rateLimitExceeded: "Too many requests. Please wait a moment.",
    },

    // Settings
    settings: {
      title: "Settings",
      payoutAddress: "Default Payout Address",
      payoutAddressHint: "Pre-filled when creating new links",
      save: "Save",
      saved: "Saved!",
    },

    // API Key
    apiKey: {
      title: "API Key",
      subtitle: "Let your Bot / AI Agent upload files and create products via API",
      backToDashboard: "Back to Dashboard",
      noKeyTitle: "You don't have an API Key yet.",
      noKeyDesc: "Create one to let your Bot upload files and create products.",
      nameLabel: "Name",
      namePlaceholder: "my-trading-bot",
      nameHint: "1-100 characters",
      createButton: "Create API Key",
      creating: "Creating...",
      fieldName: "Name",
      fieldPrefix: "Key Prefix",
      fieldCreatedAt: "Created",
      fieldLastUsed: "Last Used",
      fieldStatus: "Status",
      statusActive: "Active",
      neverUsed: "Never used",
      revokeButton: "Revoke API Key",
      modalTitle: "API Key Created",
      modalWarning: "Copy and save your API Key now. It won't be shown again.",
      modalUsage: "Usage:",
      copyButton: "Copy",
      copied: "Copied",
      confirmClose: "I've copied it, close",
      revokeTitle: "Revoke API Key",
      revokeWarning: "This API Key will be immediately invalidated. All Bots using this Key will stop working.",
      revokeIrreversible: "This action cannot be undone.",
      revokeCancel: "Cancel",
      revokeConfirm: "Revoke",
      errorLoad: "Failed to load. Please try again.",
      errorConflict: "You already have an API Key. Revoke it first to create a new one.",
      errorNameInvalid: "Invalid name. Please enter 1-100 characters.",
      errorNetwork: "Network error. Please try again later.",
      retry: "Retry",
      manageApiKey: "Manage API Key",
      manageApiKeyDesc: "Create and manage API Keys for your Bot / AI Agent.",
    },

    // Skills Page
    skills: {
      heroTitle: "Govilo Skills",
      heroSubtitle: "Let your AI agent monetize — with one skill.",
      whatIsTitle: "What is Govilo Skills?",
      whatIsDesc: "Govilo Skills lets your AI agent create paid unlock links programmatically. Upload files, set prices, and generate PayLinks — all through natural language. Works with any agent that supports skills.",
      installTitle: "Installation",
      installCommand: "npx skills add hau823823/gen-paylink-govilo",
      configTitle: "Configuration",
      configDesc: "Add your API key and payout address to .env.govilo:",
      howItWorksTitle: "How it works",
      step1Title: "Install the skill",
      step1Desc: "Add the Govilo skill to your Claude Code environment.",
      step2Title: "Configure credentials",
      step2Desc: "Set your API key and payout wallet address.",
      step3Title: "Prompt your agent",
      step3Desc: "Ask Claude to create a PayLink — it handles the rest.",
      exampleTitle: "Example usage",
      examplePrompt: "\"Create a PayLink for my trading signals PDF, price it at 5 USDC\"",
      ctaTitle: "Ready to get started?",
      ctaDesc: "Create your API key and start monetizing with AI agents.",
      ctaButton: "Create API Key",
    },
  },

  zh: {
    // Navigation
    nav: {
      home: "首頁",
      dashboard: "控制台",
      create: "建立",
      support: "支援",
      terms: "條款",
      about: "關於",
      profile: "個人檔案",
      skills: "Skills",
    },

    // Home Page
    home: {
      // Beta Banner
      betaBanner: "公開測試中 — 免費使用，歡迎回饋意見",
      betaFeedback: "提供回饋",

      // Hero
      createLink: "開始使用",

      // How it works
      howItWorks: "運作方式",
      howItWorksSubtitle: "看看你的付款如何流動 — 無需信任、完全透明",
      hiwSubtitle: "選擇你的視角來了解運作流程",
      hiwTabFlow: "付款流程",
      hiwTabSteps: "如何使用",

      // Payment Flow Animation
      pfBuyer: "買家",
      pfSeller: "賣家",
      pfSmartContract: "智能合約",
      pfOnChain: "鏈上",
      pfCaption1Main: "點對點直接付款",
      pfCaption1Sub: "無中間商。無託管風險。",
      pfCaption2Main: "智能合約保障",
      pfCaption2Sub: "你的資金不會經過我們的伺服器",
      pfCaption3Main: "即時且透明",
      pfCaption3Sub: "每筆交易都記錄在區塊鏈上",
      pfFeatNonCustodial: "非託管",
      pfFeatInstant: "即時",
      pfFeatTransparent: "透明",

      step1Title: "上傳內容",
      step1Desc: "檔案、文字或連結——任何數位內容都可以。",
      step2Title: "設定價格",
      step2Desc: "選擇你想收取的 USDC（美元穩定幣）金額。",
      step3Title: "分享連結",
      step3Desc: "透過社群、Email、私訊等任何方式發送。",
      step4Title: "買家取得內容",
      step4Desc: "他們付款，你收款，內容即時交付。",

      // Why section - 3 Pillars
      whyTitle: "為什麼選擇我們",
      pillar1Title: "全球買家",
      pillar1Desc: "買家用 USDC 付款，不受地區支付方式限制。",
      pillar2Title: "付款即交付",
      pillar2Desc: "付完自動交付內容，不用手動發檔案。",
      pillar3Title: "直達錢包",
      pillar3Desc: "款項直接轉入你的錢包，鏈上可驗證。",

      // Use cases
      whoFor: "適合對象",
      creators: "創作者",
      creatorsDesc: "直接向你的受眾銷售獨家內容 — 教學影片、設計素材、獨家照片。",
      developers: "開發者",
      developersDesc: "將程式碼、API 或技術資源變現 — 原始碼、技術文件。",
      indieSellers: "獨立賣家",
      indieSellersDesc: "無需建立商店即可銷售數位產品 — 電子書、模板、數位資源。",
      writers: "作家",
      writersDesc: "為文章、報告或優質內容設定付費牆 — 深度報告、電子報、專欄文章。",

      // Rules
      rulesTitle: "注意事項",
      ruleWarning: "請向信任的賣家購買，注意詐騙風險",
      rule1: "使用 USDC（美元穩定幣）於 Base 網路收付款",
      rule2: "零上架費，成交才收 5% 工具使用費",
      rule3: "付款後內容即交付，不可退款",
      rule4: "本工具不託管資金，不提供金融服務",
      rule5: "不保證內容品質，請自行判斷",
      rule6: "請自行確認符合當地法規",

      // CTA
      ctaTitle: "幾分鐘內建立你的第一個 PayLink。",

      heroSubtitleV2: "設定一次，你的 AI Agent 就能自動打包、定價、販售內容。",
      getApiKey: "取得 API Key",
      createPayLink: "建立 PayLink",

      // Skills Section
      skillsSectionTitle: "AI Agent 變現方案",
      skillsSectionSubtitle: "只要設定一次，你的 Agent 就能自動收費。",
      skillsCard1Title: "Agent 自動化的最後一哩",
      skillsCard1Desc: "你的 Agent 能生成內容、回答問題、做出決策 — 唯獨不能收錢。交給 Govilo，補上最後一哩路。",
      skillsCard2Title: "全自動或半自動，你決定",
      skillsCard2Desc: "可以全程交給 Agent 自主運作，也能隨時手動介入。想調整？跟 Agent 說一句話就好，不用進後台。",
      skillsCard3Title: "任何 Agent 框架，即插即用",
      skillsCard3Desc: "LangChain、CrewAI、Claude MCP，或你自己的 Pipeline — 把 Govilo 加進工具列，幾分鐘搞定。",
      skillsCta: "開始使用 Skills",

      // Footer
      about: "關於我們",
      terms: "使用條款",
      support: "支援",
    },

    // Seller Page
    seller: {
      title: "建立 PayLink",
      subtitle: "設定一次，分享連結，收款。",

      // Section titles
      contentInfo: "內容資訊",
      pricing: "定價",
      payout: "收款",
      advanced: "進階設定（選填）",

      // Content Information
      fieldTitle: "標題",
      fieldTitlePlaceholder: "例：XXX 完整指南",
      fieldDescription: "描述",
      fieldDescriptionPlaceholder: "簡單說明這是什麼內容",
      fieldContentType: "內容類型",
      contentTypeFile: "檔案",
      contentTypeText: "文字",
      contentTypeLink: "連結",
      fieldUploadFile: "上傳檔案",
      fieldUploadFilePlaceholder: "選擇檔案...",
      fieldUploadFileHint: "Mock：輸入任意檔名",
      browseBtn: "瀏覽",
      fieldContent: "內容",
      fieldContentPlaceholder: "在此輸入內容...",
      fieldContentHint: "前 20% 將顯示為預覽",
      fieldUrl: "網址",
      fieldUrlPlaceholder: "https://...",

      // Pricing
      fieldPrice: "價格",
      pricePlaceholder: "1.00",
      priceUnit: "USDC",
      priceMinError: "價格至少為 1 USDC",
      priceDecimalError: "價格小數位數不可超過 2 位",
      priceMaxError: "價格不可超過 200 USDC",
      estimated: "（估算）",

      // Payout
      fieldPayoutAddress: "收款地址",
      payoutAddressPlaceholder: "0x...",
      payoutAddressHint: "付款會直接發送至此地址。",
      invalidAddressError: "無效的以太坊地址格式",

      // Advanced
      validDuration: "有效時間",
      minutes: "分鐘",
      validDurationHint: "最多 1440 分鐘（24 小時）",
      validMinutesMinError: "有效時間必須至少 30 秒",
      validMinutesMaxError: "有效時間不能超過 24 小時",

      // Actions
      generateBtn: "產生 PayLink",
      generating: "產生中...",

      // Success
      successTitle: "PayLink 已建立！",
      copyLink: "複製連結",
      copied: "已複製",
      createAnother: "再建立一個",
      previewBuyer: "預覽買家頁面",

      // Error
      errorMessage: "發生錯誤，請重試。",

      // Navigation
      backToHome: "首頁",

      // Validation
      required: "*",

      // Multi-file upload
      dropzoneText: "拖放檔案到此處，或點擊選擇",
      dropzoneHint: "最多 20 個檔案，總計 20 MB",
      multiFileHint: "支援多檔上傳，所有檔案將打包成 ZIP 供下載。",
      fileCount: "{count} 個檔案",
      maxFilesError: "最多只能上傳 20 個檔案",
      maxSizeError: "檔案總大小不能超過 20 MB",
      removeFile: "移除檔案",
      remaining: "剩餘容量",
      filesRemaining: "個檔案可上傳",

      // Presigned URL upload states
      compressing: "正在壓縮檔案...",
      compressingProgress: "壓縮中: {progress}%",
      gettingUploadUrl: "取得上傳權限...",
      uploadingToCloud: "上傳至雲端...",
      uploadingProgress: "上傳中: {progress}%",
      creatingItem: "建立商品中...",
      sessionExpired: "上傳已逾時，請重新開始",
      rateLimitExceeded: "操作太頻繁，請稍後再試",
      zipTooLarge: "壓縮後檔案超過 20 MB 限制",

      // Turnstile
      turnstileError: "驗證失敗，請重試",

      // Coupon
      couponTitle: "優惠碼",
      couponPlaceholder: "輸入優惠碼",
      couponRedeem: "兌換",
      couponRedeeming: "兌換中...",
      couponCurrentFee: "目前平台手續費：{fee}%",
      couponActiveInfo: "優惠生效中，到期：{date}",
      couponSuccess: "優惠碼兌換成功！平台手續費降至 {fee}%。",
      couponErrorNotFound: "優惠碼無效，請確認後重試。",
      couponErrorNotRedeemable: "此優惠碼已失效。",
      couponErrorAlreadyRedeemed: "您已使用過此優惠碼。",
      couponErrorAlreadyActive: "您目前已有優惠券生效中，請等到期後再兌換。",
      couponErrorGeneric: "兌換失敗，請稍後再試。",
      promoCodeLink: "有優惠碼？前往設定兌換",
    },

    // Upload Progress Toast
    upload: {
      pendingTitle: "正在上傳檔案...",
      pendingDesc: "您的檔案正在上傳到伺服器",
      processingTitle: "正在處理檔案...",
      processingDesc: "正在處理您的檔案",
      completedTitle: "上傳完成！",
      completedDesc: "檔案已準備就緒",
      failedTitle: "上傳失敗",
      failedDesc: "請稍後再試",
      buyerWaiting: "檔案準備中，請稍後再試...",
      buyerFailedTitle: "檔案無法取得",
      buyerFailedDesc: "此商品的檔案已無法取得",
    },

    // Preview Banner
    previewBanner: "預覽模式 – 這是買家會看到的頁面",

    // Common
    common: {
      language: "語言",
      loading: "載入中...",
      backToHome: "返回首頁",
    },

    // Unlock Page (Buyer)
    unlock: {
      // Error states
      loadError: "無法載入",
      itemNotFound: "商品不存在",
      itemExpired: "商品已過期",
      itemExpiredDesc: "此商品已不再提供",
      // Status messages
      gettingPaymentInfo: "取得付款資訊...",
      checkingUnlockStatus: "檢查付款狀態...",
      checkingBalance: "檢查餘額...",
      confirmSignature: "請在錢包中簽名...",
      processingTx: "交易處理中...",
      verifyingPayment: "等待付款確認中...",
      // Price box
      unlockPrice: "取得價格",
      unlockContent: "取得內容",
      connectWallet: "連接錢包",
      switchNetwork: "切換到 {network}",
      installMetaMask: "請安裝 MetaMask",
      tryAgain: "再試一次",
      processing: "處理中...",
      unlocked: "已取得",
      switchNetworkHint: "請切換至 {network} 網路",
      // Content
      whatYouGet: "包含內容",
      copyLink: "複製連結",
      unlockForFullLink: "付款後取得完整連結",
      unlockForFullText: "付款後可查看完整內容",
      downloadFile: "下載檔案",
      // Multi-file display
      multipleFiles: "多個檔案",
      files: "個檔案",
      totalFiles: "共 {count} 個檔案",
      // Footer
      terms: "條款",
      support: "支援",
      about: "關於",

      // Viral Loop
      poweredBy: "Powered by Govilo PayLink",
      createYourOwn: "你也有獨家內容？免費建立你的 PayLink",
      createBtn: "建立我的連結",
      // Countdown & time limit
      timeRemaining: "剩餘時間",
      expired: "已過期",
      timeLimited: "時間不足，無法購買",
      timeLimitWarning: "剩餘時間不足 10 分鐘，無法購買",
      expiredNotice: "此連結已過期",
    },

    // Wallet errors
    wallet: {
      installMetaMask: "請安裝 MetaMask 錢包",
      userCancelled: "使用者取消連接",
      connectFailed: "連接錢包失敗",
      switchNetworkFailed: "切換網路失敗",
      addNetworkFailed: "無法添加 {network} 網路",
      getStatusFailed: "無法取得錢包狀態",
      switchAccountFailed: "更換錢包失敗",
      selectWallet: "選擇錢包",
      coinbaseDesc: "智能錢包或 App",
      metamaskDesc: "瀏覽器擴充或 App",
      recommended: "推薦",
      popupBlockedTitle: "請允許彈出視窗",
      popupBlockedDesc: "點擊網址列的彈出視窗圖示，選擇「允許」後重試",
      popupBlockedRetry: "重試",
      popupHintSmall: "沒反應？請點擊彈窗提示的「Retry」，或允許此網站彈出視窗",
    },

    // Payment errors
    payment: {
      getAddressFailed: "無法取得錢包地址",
      getPermitFailed: "取得付款參數失敗",
      getStatusFailed: "無法取得付款狀態",
      verifyFailed: "付款驗證失敗",
      verifyTimeout: "付款驗證超時",
      getTokenFailed: "取得下載 Token 失敗",
      submitFailed: "付款提交失敗",
      userCancelled: "使用者取消了操作",
      networkError: "網路連線錯誤，請稍後重試",
      failed: "付款失敗，請稍後重試",
      missingItemId: "缺少商品 ID",
      loadItemFailed: "無法取得商品資訊",
      itemInvalid: "此商品的檔案已無法取得",
    },

    // Download page
    download: {
      invalidLink: "無效的下載連結",
      invalidLinkDesc: "此連結無效或已過期",
      success: "付款成功！",
      successDesc: "付款成功！點擊下方按鈕開始下載",
      downloadBtn: "下載檔案",
      tokenExpired: "下載連結已過期",
      tokenUsed: "下載連結已被使用",
      downloadFailed: "下載失敗，請重試",
    },

    // Terms Modal
    termsModal: {
      // TOS
      tosTitle: "使用條款",
      tosAcceptBtn: "我同意",
      tosLink: "查看完整使用條款",

      // Buyer
      buyerTitle: "平台免責聲明",
      buyerContent: "購買前請確認並同意以下條款：",
      buyerItem1: "我了解這是「數位內容解鎖」服務，付款後會立即取得解鎖權限。",
      buyerItem2: "我會自行確認內容說明、價格與限制，付款決定由我自行負責。",
      buyerItem3: "付款成功後概不退款／不撤銷。",
      buyerItem4: "平台僅提供付款與解鎖工具，不是交易當事人；內容品質、描述是否符合、或任何糾紛，應由買賣雙方自行處理。",
      buyerItem5: "鏈上交易為不可逆，我會自行確認鏈別、金額與地址；因付款錯誤造成的損失由我自行承擔。",
      buyerItem6: "我理解並同意自行防範詐騙，並確認賣家為我信任的對象後再付款；若我遭遇詐騙或交易糾紛，平台無法介入、無法協助追回款項或處理任何賠償。",
      buyerAcceptBtn: "我了解並同意，繼續購買",

      // Seller
      sellerTitle: "平台免責聲明",
      sellerContent: "上架前請確認並同意以下條款：",
      sellerItem1: "我確認我有權提供與販售此內容，且不侵害第三人權利（著作權、肖像權、隱私等）。",
      sellerItem2: "我保證內容合法，不包含侵權盜版、未經同意外流、未成年不當內容、詐騙、洗錢或其他非法用途。",
      sellerItem3: "內容描述、售價、交付與售後政策由我自行負責；因描述不清或消費爭議造成的後果由我承擔。",
      sellerItem4: "平台僅提供付款與解鎖技術，不審核內容、不提供交易保證；任何糾紛或損害，平台不負責。",
      sellerItem5: "我理解鏈上結算不可逆；因我設定錯誤（收款地址／內容設定等）造成的損失由我承擔。",
      sellerItem6: "若平台合理懷疑內容或交易涉及違法／高風險，平台可限制或暫停服務，我不得要求平台賠償。",
      sellerAcceptBtn: "我了解並同意，繼續上架",

      // Common
      cancel: "取消",
      processing: "處理中...",
      scrollToRead: "請向下捲動以閱讀完整條款",
    },

    // Terms of Service
    terms: {
      title: "使用條款",
      subtitle: "平台型數位內容付費解鎖服務",
      lastUpdated: "最後更新日期",

      // Section 1 - 前言與同意條款
      section1Title: "一、前言與同意條款",
      section1Content: "歡迎使用本平台（以下稱「本平台」）。當使用者存取、瀏覽或使用本平台所提供之任何服務，即表示使用者已充分閱讀、理解並同意受本《使用條款》及相關政策（包含但不限於隱私權政策、禁止用途政策）之約束。",
      section1Warning: "若使用者不同意本條款之任何內容，請立即停止使用本平台服務。",

      // Section 2 - 服務內容說明
      section2Title: "二、服務內容說明",
      section2Content1: "本平台提供數位內容付費解鎖之技術與系統工具，使內容提供者（以下稱「賣方」）得以透過智能合約、區塊鏈交易或特定連結，向使用者（以下稱「買方」）提供數位內容之存取權限。",

      // 2.1 技術性質與非託管聲明
      section2_1Title: "2.1 技術性質與非託管（Non-custodial）聲明",
      section2_1Intro: "使用者理解並同意，本平台之服務屬於「技術工具／軟體系統」性質，包含但不限於：",
      section2_1Item1: "協助賣方建立內容解鎖頁面或存取連結；",
      section2_1Item2: "提供買方付款後之解鎖驗證與存取權限開通；",
      section2_1Item3: "依據公開可驗證之鏈上交易資訊或系統紀錄，呈現付款狀態、解鎖狀態與存取紀錄；",
      section2_1Item4: "提供通報、風控處置、下架與限制存取等管理機制。",
      section2_1NonCustody: "本平台不提供、亦不涉及任何形式之資產託管或代為保管服務。本平台不持有使用者私鑰、不代替使用者簽署交易，亦不以任何方式對使用者之加密資產具有單方控制、移轉或處分之能力。所有加密資產之移轉均由使用者自行控制之錢包依其指令於區塊鏈網路上完成。本平台不提供任何代收代付或資金中繼服務。",

      // 2.2 本平台非交易當事人
      section2_3Title: "2.2 本平台非交易當事人",
      section2_3Content: "本平台僅為技術工具與系統提供者，並非交易當事人，亦不直接提供、控制、審核、保證或持有任何賣方所提供之內容或加密資產。買賣雙方就內容交易所成立之法律關係，均由賣方與買方自行負責。",

      // Section 3 - 使用者角色與責任
      section3Title: "三、使用者角色與責任",

      // 3.1 賣方責任
      section3_1Title: "3.1 賣方責任",
      section3_1Intro: "賣方對其內容和交易承擔完全且獨立的法律責任，並應就所有相關索賠對本平台進行賠償。",
      section3_1ContentDef: "賣方確認並同意，其透過本平台所提供、上架、販售、發布、展示、傳輸、交付或使買方得以存取之任何內容、檔案、連結、素材、文字描述、圖片、影音、服務、權利、授權或其他數位商品（以下合稱「賣方內容」），均由賣方自行負完全、獨立且排他之法律責任。本平台僅提供技術工具，不對賣方內容之合法性、正確性、完整性、安全性、品質、可用性或適用性作任何明示或默示之保證。",
      section3_1WarrantyIntro: "賣方特此聲明、保證並承諾如下：",

      // 賣方保證項目
      section3_1LegalTitle: "內容合法性與合規責任",
      section3_1LegalContent: "賣方所提供之賣方內容及其交易行為，均符合所有適用之法律、法規、命令、規則及主管機關或相關監管要求（包含但不限於消費者保護、個人資料保護、智慧財產權、刑事法律、洗錢防制及資恐防制等），且賣方已取得其依法應具備之一切資格、授權、許可或同意。",

      section3_1ProhibitedTitle: "禁止違法用途與高風險交易",
      section3_1ProhibitedIntro: "賣方不得利用本平台從事任何違法或不當用途，包含但不限於：",
      section3_1ProhibitedItem1: "詐欺、詐騙、不實銷售、投資騙局、資金盤或任何不實募集資金行為",
      section3_1ProhibitedItem2: "洗錢、資恐、非法集資、資金掩飾、分層轉移、代收代付或任何金融犯罪",
      section3_1ProhibitedItem3: "以「內容」名義實質從事非法資金移轉、變相收款、代幣販售或規避監管之行為",
      section3_1ProhibitedItem4: "任何教唆、協助或誘導他人從事犯罪之內容或行為",

      section3_1ContentTitle: "禁止販售或散布之內容類型（含非法與高風險內容）",
      section3_1ContentIntro: "賣方不得提供、販售、分享或使買方得以存取任何包含但不限於下列類型之內容：",
      section3_1ContentItem1: "未經授權之盜版內容、侵權資源、破解程式、序號、破解教學或任何侵害智慧財產權之資料",
      section3_1ContentItem2: "猥褻、色情、露骨性內容，或任何涉及性暴力、性剝削之內容",
      section3_1ContentItem3: "涉及未成年人之不當內容、剝削、性暗示、裸露或任何可能違法之內容",
      section3_1ContentItem4: "暴力、血腥、殘虐、恐嚇、仇恨煽動、歧視性內容",
      section3_1ContentItem5: "侵犯他人隱私之內容（如個資外流、偷拍、外流影像、未經同意之對話紀錄與定位資訊等）",
      section3_1ContentItem6: "任何依法禁止流通、依法須特許方可提供，或可能使本平台面臨重大法律風險之內容或服務",

      section3_1MisleadingTitle: "不得作出誤導性或不實陳述",
      section3_1MisleadingContent: "賣方對其賣方內容之標題、描述、示意、交付方式、使用限制、價格、風險提示、適用條件及其他交易資訊，應完整、清楚、真實，不得有任何虛偽、誇大、重大遺漏、引人錯誤或足以誤導買方之陳述或行為。",

      section3_1IPTitle: "智慧財產權與第三人權利保證",
      section3_1IPContent: "賣方保證其賣方內容不侵害任何第三人之合法權利，包括但不限於：著作權、商標權、專利權、營業秘密或其他智慧財產權，以及隱私權、個人資料權益、肖像權、姓名權、名譽權或其他依法受保護之權利。若賣方內容涉及第三方素材（包含圖片、音樂、影片、字型、程式碼、模型、資料集等），賣方應自行取得合法授權並負擔所有相關責任與費用。",

      section3_1DeliveryTitle: "賣方自行處理交付、售後與爭議",
      section3_1DeliveryContent: "賣方應自行負責其內容交付、授權方式、下載/存取方式、售後支援及買方疑問回覆，並自行處理其與買方間因內容品質、交付瑕疵、描述不符、權利授權、售後問題或任何糾紛所生之一切責任。本平台不負任何形式之交付義務、審核義務、保固義務或仲裁義務。",

      section3_1DisputeTitle: "買賣爭議與申訴處理責任",
      section3_1DisputeContent: "若買方對賣方內容提出申訴、異議、爭議、退款要求或任何主張，均由賣方自行處理與回應。賣方理解並同意，本平台得依風險控管或合法需求，要求賣方提供必要之交易資訊、說明文件或權利證明，以協助處理申訴或調查。",

      section3_1EnforcementTitle: "平台風控措施與處置權",
      section3_1EnforcementIntro: "本平台得基於法律遵循、風險控管、使用者保護或合理懷疑賣方行為異常之情況，於不事先通知賣方之情形下，採取包括但不限於以下措施：",
      section3_1EnforcementItem1: "限制、暫停或終止賣方使用本平台全部或部分功能",
      section3_1EnforcementItem2: "下架、移除、封鎖賣方內容或相關連結",
      section3_1EnforcementItem3: "要求賣方提供身份或權利證明、授權文件或補充說明",
      section3_1EnforcementItem4: "依法配合主管機關、司法機關或其他具合法權限之單位提供必要資訊",

      section3_1IndemnityTitle: "賠償與補償義務（Indemnification）",
      section3_1IndemnityContent: "如因賣方之行為或賣方內容（包含但不限於違法、侵權、詐欺、洗錢、誤導陳述、爭議交易或任何違反本條款之情形），導致本平台、本平台之關係企業、股東、董事、員工、合作夥伴或受任人遭任何第三人或主管機關主張、申訴、索賠、調查、裁罰、扣押、訴訟或仲裁，賣方應自行負責處理並承擔全部責任，並應賠償本平台因此所生之一切損害、費用與支出（包含但不限於律師費、訴訟費、和解金、行政罰鍰及商譽損失）。",

      section3_1SurvivalTitle: "責任持續有效",
      section3_1SurvivalContent: "本條第 3.1 條所定之賣方義務與責任，不因賣方停止使用本平台、刪除內容或終止服務而失效，仍持續有效。",

      // 3.2 買方責任
      section3_2Title: "3.2 買方責任",
      section3_2Intro: "買方必須在付款前仔細評估內容描述、交易條款和風險。買方確認並同意：",

      section3_2JudgeTitle: "買方應自行判斷內容與交易是否符合需求",
      section3_2JudgeContent: "買方應於付款前自行審慎確認賣方所提供之內容說明、交付方式、授權範圍、使用限制、相容性、風險提示及任何附帶條件，並自行評估是否符合自身需求。買方理解並同意，本平台不審核、不保證賣方內容之品質、正確性、合法性或適用性。",

      section3_2NoGuaranteeTitle: "買方不得將本平台視為擔保或保證機制",
      section3_2NoGuaranteeContent: "買方理解並同意，本平台僅提供技術工具與解鎖機制，並非買賣契約之當事人。本平台不提供任何形式之交易擔保、履約保證、託管、仲裁或代為求償服務。",

      section3_2BlockchainTitle: "交易由買方自行錢包發起，並透過區塊鏈與智能合約執行",
      section3_2BlockchainContent: "交易透過買方自行控制之錢包完成簽署與廣播，並由區塊鏈網路與 USDC 官方智能合約依其規則執行。買方理解並同意，一旦買方於錢包中完成簽署、授權或支付（包含但不限於 transfer 等行為），即視為買方已確認並同意該交易之條件與結果。",

      section3_2ControlTitle: "交易完成後付款資產將移轉至賣方地址，買方取得內容存取權",
      section3_2ControlContent: "交易確認後，付款用之 USDC 將依區塊鏈交易結果移轉至賣方所設定之收款地址；買方取得對所購賣方內容之存取權限或下載權限（依賣方設定之交付方式而定）。本平台不保證賣方內容之品質或交付完整性。",

      section3_2IrreversibleTitle: "區塊鏈交易不可逆",
      section3_2IrreversibleContent: "區塊鏈交易不可逆轉，超出本平台的控制範圍。買方理解並同意，交易一旦在區塊鏈上確認或進入不可撤銷狀態，即可能無法取消或回復。",

      section3_2NoRefundTitle: "本平台無法撤銷、攔截、回滾或退款交易",
      section3_2NoRefundContent: "一旦付款完成並授予存取權限，交易即為最終且不可取消。買方確認，由於交易是透過買方自行發起之鏈上交易執行，本平台沒有技術能力或法律義務來撤銷、攔截、回滾或退款任何交易。買方如需退款或爭議處理，應直接與賣方協商。",

      section3_2AccessRiskTitle: "內容存取與交付風險由買方自行承擔",
      section3_2AccessRiskContent: "買方理解並同意，賣方內容可能以檔案下載、解鎖頁面、外部連結、第三方儲存服務或其他方式提供。買方應自行確認自身裝置、網路環境、瀏覽器、安全設定及相容性狀態足以完成存取。因買方設備故障、網路中斷、相容性問題、錢包操作失誤、錯誤地址、錯誤鏈別、誤簽署或其他買方因素造成之損失，本平台概不負責。",

      section3_2FeesTitle: "交易費用與鏈上成本",
      section3_2FeesContent: "買方理解並同意，除內容付款金額外，可能需另行支付區塊鏈交易手續費（gas fee）或其他第三方費用。該等費用由區塊鏈網路或第三方收取，非本平台可控制或退還。",

      section3_2DirectDisputeTitle: "買方與賣方間的爭議應由雙方自行處理",
      section3_2DirectDisputeContent: "買方理解並同意，若對賣方內容產生疑義、爭議、瑕疵、描述不符或其他糾紛，買方應直接向賣方主張權利並自行協商處理，本平台不作為交易當事人，亦不負責協調、仲裁或擔保賣方履約。",

      section3_2LegalUseTitle: "買方應合法使用內容",
      section3_2LegalUseContent: "買方不得將解鎖內容用於任何違法用途，亦不得進行非法散布、重製、轉售、分享或其他侵害賣方或第三人權利之行為。買方如違反前述義務，應自行承擔全部法律責任。",

      // Section 4 - 付款與交易性質
      section4Title: "四、付款與交易性質",
      section4Content1: "本平台僅支援加密資產（如穩定幣 USDC）作為付款方式，不支援任何形式之法定貨幣（法幣）交易。",
      section4Content2: "使用者理解並同意：",
      section4Item1: "本平台非金融機構、支付機構或電子支付業者。",
      section4Item2: "本平台不參與、不保管、不控制任何使用者之資金或加密資產。",
      section4Item3: "本平台不提供虛擬資產兌換、買賣撮合、或代收代付服務。",
      section4Item4: "交易結果完全取決於區塊鏈網路與智能合約之執行狀態。",
      section4Item5: "本平台僅在交易成功時向賣方收取 5% 工具使用費，買方無需支付任何工具使用費用。",
      section4Item6: "未來收費方案如有調整，將於平台公告。",

      // Section 5 - 平台角色與責任限制
      section5Title: "五、平台角色與責任限制",
      section5Content1: "本平台不屬於買賣雙方之代理人、保證人或代表，亦非投資、理財或金融顧問。",
      section5Content2: "本平台不對以下事項負任何責任：",
      section5Item1: "賣方內容之品質、合法性、正確性或適用性。",
      section5Item2: "買賣雙方間之任何爭議或糾紛。",
      section5Item3: "因使用或解鎖內容所生之一切直接或間接損害。",
      section5Item4: "因第三方錢包、區塊鏈網路、節點/RPC、USDC 智能合約、或其他第三方服務之故障、延遲或異常所生之損失。",

      // Section 6 - 智慧財產權
      section6Title: "六、智慧財產權",
      section6Content1: "本平台之系統、程式碼、介面設計與標示，均屬本平台或其合法權利人所有。",
      section6Content2: "賣方內容之智慧財產權仍歸賣方或原權利人所有。",

      // Section 7 - 存取方式與使用者安全
      section7Title: "七、存取方式與使用者安全",
      section7Content1: "部分服務可能不需註冊帳戶，而係以錢包簽名、交易紀錄或特定連結作為存取依據。",
      section7Content2: "使用者應自行妥善保管其錢包、私鑰與存取憑證；因使用者自身疏失所致之損失，本平台概不負責。",

      // Section 8 - 服務中斷與終止
      section8Title: "八、服務中斷與終止",
      section8Content: "本平台得於任何時間暫停、限制或終止全部或部分服務，包括但不限於系統維護、法律要求或異常使用行為。",

      // Section 9 - 免責聲明
      section9Title: "九、免責聲明",
      section9Content1: "本平台依「現況（as-is）」提供服務，不保證服務不中斷、即時或無錯誤。",
      section9Content2: "在法律允許之最大範圍內，本平台不對任何間接、附帶、衍生性或懲罰性損害負責。",

      // Section 10 - 條款修訂
      section10Title: "十、條款修訂",
      section10Content: "本平台得隨時修訂本條款，修訂後公布於平台即生效。",

      // Section 11 - 準據法與爭議處理
      section11Title: "十一、準據法與爭議處理",
      section11Content1: "本條款之解釋與適用，應依本平台主要營運所在地之相關法律為準據法。",
      section11Content2: "因本條款或本平台服務所生之一切爭議，雙方應先誠信協商解決；如無法協商，則由本平台主要營運地具管轄權之法院或合法爭議解決機制處理。",

      // Section 12 - 風險揭露與反詐騙提醒
      section12Title: "十二、風險揭露與反詐騙提醒",
      section12Intro: "使用者理解並同意，本平台涉及區塊鏈與智能合約之技術特性，並存在包含但不限於下列風險：",
      section12Risk1Title: "交易不可逆風險",
      section12Risk1Content: "區塊鏈交易一經確認，通常不可撤銷或回復。",
      section12Risk2Title: "地址與鏈別錯誤風險",
      section12Risk2Content: "若使用者輸入錯誤地址、選錯鏈別或誤授權，可能造成資產永久損失。",
      section12Risk3Title: "智能合約與第三方服務風險",
      section12Risk3Content: "交易可能受智能合約、錢包供應商、RPC/節點、區塊鏈網路壅塞等因素影響。",
      section12Risk4Title: "內容詐騙風險",
      section12Risk4Content: "賣方可能提供不實內容描述、未交付內容、交付惡意連結或其他詐騙行為。",
      section12ScamWarning: "本平台提醒買方於付款前應審慎查核賣方資訊與內容描述，避免下列常見詐騙情境：",
      section12ScamItem1: "以「限時」或「保證獲利」誘導快速付款",
      section12ScamItem2: "引導至非官方頁面要求額外轉帳或提供私鑰/助記詞",
      section12ScamItem3: "解鎖後提供可疑檔案、釣魚連結或要求額外付款才交付內容",
      section12Disclaimer: "本平台不保證可防止所有詐騙事件發生，惟本平台將在合理範圍內依本條款與內部風控機制處理檢舉與異常行為。",

      // Section 13 - 通報、處置與鏈上資訊提供
      section13Title: "十三、通報、處置與鏈上資訊提供",

      section13ReportTitle: "通報機制",
      section13ReportContent: "使用者若發現疑似詐騙、侵權、違法內容或其他異常情事，得向本平台提出通報。本平台得要求通報者提供必要資訊（如頁面連結、交易哈希、截圖、對話紀錄等）以利處理。",

      section13EnforcementTitle: "平台可採行之合理處置",
      section13EnforcementIntro: "本平台在合理懷疑有詐騙或違規情形時，得採取包括但不限於下列措施：",
      section13EnforcementItem1: "下架或限制存取涉疑內容/連結",
      section13EnforcementItem2: "限制、暫停或終止涉疑賣方之使用權限",
      section13EnforcementItem3: "保留相關紀錄，以供後續調查或依法配合",

      section13InfoTitle: "本平台可提供之資訊範圍",
      section13InfoContent: "使用者理解並同意，本平台可提供或協助整理之資訊範圍，通常僅限於與本平台系統相關之紀錄以及公開可驗證之鏈上交易資訊（例如交易哈希、合約地址、事件紀錄等），但本平台不保證可取得或提供任何非本平台所持有之資料。",

      section13NoRecoveryTitle: "不保證追回損失",
      section13NoRecoveryContent: "使用者理解並同意，本平台並非執法機關或仲裁機構，本平台之處置不代表可追回損失、撤銷交易或保證賠償結果。",

      // Section 14 - 合規配合與資料留存
      section14Title: "十四、合規配合與資料留存",
      section14Content1: "使用者理解並同意，為遵循法律及風險控管目的，本平台得於合理範圍內留存必要之系統紀錄（例如裝置/瀏覽資訊、存取紀錄、交易相關識別資訊等）。",
      section14Content2: "如依法令、主管機關或司法機關要求，本平台得在法律允許範圍內提供必要資訊或配合調查。使用者同意，本平台依前述目的之資料處理與提供，不構成對使用者之任何義務擔保或責任承擔。",

      // Section 15 - 責任限制
      section15Title: "十五、責任限制",
      section15Intro: "在法律允許之最大範圍內，使用者理解並同意：",
      section15Item1: "本平台不對賣方內容或賣方行為所生之任何損害負責。",
      section15Item2: "本平台不對使用者因區塊鏈交易不可逆、第三方錢包/網路/服務異常、或使用者自身操作失誤所生之損害負責。",
      section15Item3: "即使本平台需負部分責任，本平台之責任範圍亦應以使用者於引發爭議事件前十二（12）個月內實際支付予本平台之服務費總額為上限（如無支付則以美元（USD）零元計），且不包含任何間接、附帶、衍生性或懲罰性損害。",

      // Appendix 1 - 禁止用途政策 (AUP)
      appendix1Title: "附錄一：禁止用途政策（Acceptable Use Policy, AUP）",
      appendix1Intro: "（本附錄為本《使用條款》之一部分，具有同等效力）",
      appendix1Purpose: "為維護使用者安全、避免非法內容流通及降低平台法律風險，使用者（包含賣方與買方）於使用本平台時，應遵守下列禁止用途政策。",

      appendix1ContentTitle: "一、禁止提供或販售之內容",
      appendix1ContentIntro: "使用者不得透過本平台提供、販售、散布、分享或引導存取下列內容（包含但不限於文字、圖片、影音、檔案、連結、程式碼或其他形式）：",
      appendix1ContentItem1: "侵害智慧財產權或未經授權之盜版內容（包含破解、序號、非法重製、未授權教材與付費內容外流等）。",
      appendix1ContentItem2: "猥褻、色情、露骨性內容，或涉及性暴力、性剝削之內容。",
      appendix1ContentItem3: "涉及未成年人之不當內容（包含任何可能違法或不當之裸露、性暗示、剝削）。",
      appendix1ContentItem4: "暴力、血腥、虐待、恐嚇、煽動仇恨或歧視性內容。",
      appendix1ContentItem5: "侵犯隱私之內容（包含個資外流、偷拍、外流影像、未經同意之對話紀錄與定位資訊等）。",
      appendix1ContentItem6: "任何依法禁止流通或依法須特許方可提供之內容或服務。",

      appendix1BehaviorTitle: "二、禁止行為",
      appendix1BehaviorIntro: "使用者不得利用本平台從事下列行為：",
      appendix1BehaviorItem1: "詐欺、詐騙、釣魚、偽冒他人身分或不實銷售。",
      appendix1BehaviorItem2: "洗錢、資恐、非法集資、代收代付、資金掩飾、規避監管或其他金融犯罪。",
      appendix1BehaviorItem3: "散布惡意程式、病毒、木馬、勒索軟體、或提供駭客工具與入侵教學。",
      appendix1BehaviorItem4: "未經授權存取本平台系統、干擾服務運作、進行爬蟲攻擊、DoS/DDoS 攻擊或任何破壞行為。",
      appendix1BehaviorItem5: "利用本平台進行騷擾、威脅、恐嚇、霸凌、仇恨言論或歧視行為。",
      appendix1BehaviorItem6: "任何違反公共秩序與善良風俗之行為。",

      appendix1EnforcementTitle: "三、平台執行措施",
      appendix1EnforcementContent: "如本平台認為使用者行為或內容可能違反本政策或存在風險，本平台得不經事先通知即採取措施，包括但不限於移除、封鎖、下架內容或限制/終止使用權，並依法配合主管機關或司法機關提供資料。",

      // Appendix 2 - 侵權通知與下架機制
      appendix2Title: "附錄二：侵權通知與下架機制（Notice & Takedown）",
      appendix2Intro: "（本附錄為本《使用條款》之一部分，具有同等效力）",
      appendix2Purpose: "本平台尊重智慧財產權及第三人合法權利。若權利人或其合法代理人認為本平台上存在侵害其權利之內容，得依下列流程提出通知。",

      appendix2NoticeTitle: "一、通知方式",
      appendix2NoticeIntro: "權利人應提供下列資訊（內容越完整，本平台越能快速處理）：",
      appendix2NoticeItem1: "權利人姓名/名稱、聯絡方式（電子郵件、電話等）",
      appendix2NoticeItem2: "權利證明文件或權利聲明（如著作權證明、授權證明、商標權證明等）",
      appendix2NoticeItem3: "涉嫌侵權內容之具體位置資訊（例如：商品頁面連結、內容識別資訊）",
      appendix2NoticeItem4: "權利人確認其為權利人或合法代理人之聲明",
      appendix2NoticeItem5: "權利人確認通知內容真實且願負法律責任之聲明",

      appendix2ProcessTitle: "二、平台處理流程",
      appendix2ProcessContent: "本平台在收到通知後，得依個案情況採取包括但不限於暫時下架、限制存取、通知賣方提出授權證明或補充說明等措施。",

      appendix2CounterTitle: "三、賣方反通知（Counter Notice）",
      appendix2CounterContent: "若賣方主張其內容未侵權或已取得合法授權，賣方得向本平台提出反通知並提供相應證明文件。本平台得依個案情況決定是否恢復內容或維持下架處理。",

      appendix2RepeatTitle: "四、重複侵權與帳戶處置",
      appendix2RepeatContent: "本平台得對於多次涉嫌侵權、屢次違反本條款或存在重大法律風險之賣方，採取限制、暫停或終止使用權之措施。",

      appendix2LiabilityTitle: "五、責任限制",
      appendix2LiabilityContent: "使用者理解並同意，本平台僅提供技術工具並非侵權內容之提供者或交易當事人。對於侵權爭議之最終責任，仍由內容提供者（賣方）自行承擔。",
    },

    // Support Page
    support: {
      title: "支援中心",
      subtitle: "我們隨時為你提供協助",

      // Contact
      contactTitle: "聯絡我們",
      contactDesc: "有問題或需要協助？請發送電子郵件，我們會盡快回覆。",
      responseTime: "我們通常會在 24-48 小時內回覆。",

      // FAQ
      faqTitle: "常見問題",

      faq1Question: "什麼是 Govilo PayLink？",
      faq1Answer: "Govilo PayLink 是一個數位內容付款工具，讓你可以透過簡單的付款連結銷售檔案、文字或連結。買家使用 Base 區塊鏈上的 USDC 付款，付款後內容會自動交付。",

      faq2Question: "我如何收到款項？",
      faq2Answer: "款項會直接發送到你的錢包地址。當你建立 PayLink 時，你需要指定收款地址，買家付款後資金會立即發送到該地址。平台不會代為保管你的資金。",

      faq3Question: "支援哪些付款方式？",
      faq3Answer: "我們目前支援 Base 區塊鏈上的 USDC 付款。買家需要使用相容的錢包（如 Coinbase Wallet 或 MetaMask）進行購買。",

      faq4Question: "可以退款嗎？",
      faq4Answer: "由於區塊鏈交易和數位內容即時交付的特性，所有銷售均為最終交易。付款完成後無法撤銷或退款。",

      faq5Question: "平台收取多少費用？",
      faq5Answer: "平台僅在成功交易時向賣家收取 5% 工具使用費，買家不需支付任何工具使用費用。此外，買家可能需支付少量區塊鏈 Gas 費（大約 $0.1）。",

      faq6Question: "PayLink 的有效期是多久？",
      faq6Answer: "建立連結時，你可以設定有效期限（最長 24 小時）。連結過期後將無法購買或下載，請在有效期限內完成下載。",

      faq7Question: "我有足夠的 USDC，為什麼無法購買？",
      faq7Answer: "你需要一點點 ETH（大約 $0.1）來支付網路手續費（稱為「Gas」）。可以把它想成寄送付款的「郵資」。",

      faq8Question: "為什麼我可以信任這個平台？",
      faq8Answer: "付款流程完全透明。從付款到收款，每個步驟都記錄在區塊鏈上，你隨時可以查看。",
      faq8Link: "前往 Basescan 查看合約",
      faq8LinkUrl: "https://basescan.org/address/0xF40e8a42250D140CcdD312aC93AFCB1b0c5f935C",

      // Getting Started Section
      gettingStartedTitle: "新手指南",

      walletTitle: "什麼是收款地址？",
      walletDesc: "收款地址是你的加密貨幣錢包地址，用來接收付款。它看起來像這樣：0x1234...abcd。如果你還沒有錢包，可以免費建立一個：",
      walletLink1: "Coinbase Wallet",
      walletLink1Desc: "新手首選，簡單好上手",
      walletLink1Badge: "推薦",
      walletLink2: "MetaMask",
      walletLink2Desc: "熱門瀏覽器擴充",
      walletGuideLink: "如何建立錢包（新手教學）",

      baseTitle: "什麼是 Base？",
      baseDesc: "Base 是由 Coinbase 建立的區塊鏈網路，具有快速、低成本和安全的特點。Govilo PayLink 上的所有交易都在 Base 上進行，相比以太坊主網費用更低。",
      baseLink: "了解更多關於 Base",

      usdcTitle: "什麼是 USDC？",
      usdcDesc: "USDC 是一種與美元 1:1 掛鉤的穩定幣。與波動性大的加密貨幣不同，1 USDC 始終等於 1 美元。它由 Circle 發行，是最受信任的穩定幣之一。",
      usdcLink: "了解更多關於 USDC",

      // Report
      reportTitle: "回報問題",
      reportDesc: "我們可以協助處理技術問題和內容政策違規。請透過電子郵件聯繫我們：",
      reportItem1: "技術問題（付款錯誤、下載問題等）",
      reportItem2: "著作權侵權檢舉",
      reportItem3: "違法或違規內容下架請求",
      reportInclude: "請附上：",
      reportIncludeItem1: "相關連結或頁面網址",
      reportIncludeItem2: "螢幕截圖（如適用）",
      reportIncludeItem3: "問題的詳細描述",
      reportNote: "注意：由於區塊鏈交易的特性，我們無法撤銷或退還已完成的付款。",
    },

    // Auth
    auth: {
      loading: "載入中...",
      loginRequired: "請先登入",
      loginRequiredDesc: "使用 Google 帳號登入以建立 PayLink。",
      signInWithGoogle: "使用 Google 登入",
      logout: "登出",
      profile: "個人資料",
      loginError: "登入失敗，請重試",
      sessionExpired: "登入已過期，請重新登入",
      inAppBrowserWarning: "Google 登入無法在此瀏覽器中使用，請用 Safari 或 Chrome 開啟。",
      copyUrl: "複製網址後用瀏覽器開啟",
      urlCopied: "已複製網址！",
    },

    // Dashboard
    dashboard: {
      title: "控制台",
      totalRevenue: "總收入",
      itemsSold: "已售出",
      activeLinks: "有效連結",
      myLinks: "我的 PayLink",
      createNew: "建立新連結",
      noLinks: "尚無連結",
      noLinksDesc: "建立第一個 PayLink 開始銷售",
      active: "有效",
      expired: "已過期",
      copyLink: "複製連結",
      linkCopied: "已複製!",
      viewDetails: "查看詳情",
      sales: "銷售",
      created: "建立於",
      expires: "到期於",
      expiresIn: "剩 {time}",
      expiredAgo: "已過期 {time}",
      timeMinutes: "{n} 分鐘",
      timeHours: "{n} 小時",
      timeHoursMinutes: "{h} 小時 {m} 分",
      timeDays: "{n} 天",
      price: "價格",
      status: "狀態",
      itemTitle: "標題",
      revenue: "收入",
      welcomeBack: "歡迎回來",
      prevPage: "上一頁",
      nextPage: "下一頁",
      sessionExpired: "登入已過期",
      sessionExpiredDesc: "您的登入階段已過期，請重新登入以繼續使用。",
      rateLimitExceeded: "請求過於頻繁，請稍後再試。",
    },

    // Settings
    settings: {
      title: "設定",
      payoutAddress: "預設收款地址",
      payoutAddressHint: "建立新連結時自動填入",
      save: "儲存",
      saved: "已儲存!",
    },

    // API Key
    apiKey: {
      title: "API Key",
      subtitle: "讓你的 Bot / AI Agent 透過 API 上傳並建立商品",
      backToDashboard: "返回 Dashboard",
      noKeyTitle: "你目前沒有 API Key。",
      noKeyDesc: "建立一把讓你的 Bot 能上傳檔案並建立商品。",
      nameLabel: "名稱",
      namePlaceholder: "my-trading-bot",
      nameHint: "1-100 字元",
      createButton: "建立 API Key",
      creating: "建立中...",
      fieldName: "名稱",
      fieldPrefix: "金鑰前綴",
      fieldCreatedAt: "建立時間",
      fieldLastUsed: "最後使用",
      fieldStatus: "狀態",
      statusActive: "啟用中",
      neverUsed: "尚未使用",
      revokeButton: "撤銷 API Key",
      modalTitle: "API Key 已建立",
      modalWarning: "請立即複製並妥善保存你的 API Key，此金鑰不會再次顯示。",
      modalUsage: "使用方式：",
      copyButton: "複製",
      copied: "已複製",
      confirmClose: "我已複製，關閉",
      revokeTitle: "確認撤銷 API Key",
      revokeWarning: "撤銷後此 API Key 將立即失效，所有使用此 Key 的 Bot 將無法繼續運作。",
      revokeIrreversible: "此操作無法復原。",
      revokeCancel: "取消",
      revokeConfirm: "確認撤銷",
      errorLoad: "載入失敗，請稍後再試",
      errorConflict: "你已有一把 API Key，請先撤銷再建立新的",
      errorNameInvalid: "名稱格式錯誤，請輸入 1-100 字元",
      errorNetwork: "網路錯誤，請稍後再試",
      retry: "重試",
      manageApiKey: "管理 API Key",
      manageApiKeyDesc: "建立與管理你的 Bot / AI Agent 使用的 API Key。",
    },

    // Skills Page
    skills: {
      heroTitle: "Govilo Skills",
      heroSubtitle: "讓你的 AI Agent 能變現 — 只需一個 MCP Skill。",
      whatIsTitle: "什麼是 Govilo Skills？",
      whatIsDesc: "Govilo Skills 讓你的 AI Agent 能建立付費解鎖連結。上傳檔案、設定價格、產生 PayLink — 全部透過自然語言完成。任何支援 skill 的 Agent 都能使用。",
      installTitle: "安裝方式",
      installCommand: "npx skills add hau823823/gen-paylink-govilo",
      configTitle: "設定",
      configDesc: "在 .env.govilo 中加入你的 API Key 和收款地址：",
      howItWorksTitle: "運作方式",
      step1Title: "安裝 Skill",
      step1Desc: "將 Govilo Skill 加入你的 Claude Code 環境。",
      step2Title: "設定憑證",
      step2Desc: "設定你的 API Key 和收款錢包地址。",
      step3Title: "提示你的 Agent",
      step3Desc: "請 Claude 建立 PayLink — 它會處理剩下的。",
      exampleTitle: "使用範例",
      examplePrompt: "「幫我建立一個交易訊號 PDF 的 PayLink，定價 5 USDC」",
      ctaTitle: "準備好開始了嗎？",
      ctaDesc: "建立你的 API Key，開始用 AI Agent 變現。",
      ctaButton: "建立 API Key",
    },
  },
} as const;

export type Locale = keyof typeof locales;
export type Translations = typeof locales.en;
